import {CurrencyComponent} from "../../currency-component/CurrencyComponent.tsx";
import React from "react";
import type {DeserializedGridCellParams} from "../MuiXColumnDefinitions.ts";

export const CurrencyCell: React.FC<DeserializedGridCellParams> = (props) => {
    const value = props.value;
    if (!value) return <></>
    return <CurrencyComponent v={value} nDigits={3}/>
}
